export const weaponDefs = [
  {
    id: 'smg',
    name: 'Pulse SMG',
    meta: '1 - Manual - Starter',
    key: '1',
    cooldown: 0.15,
    pellets: 1,
    spread: 0.014,
    speed: 46,
    damage: 1.05,
    radius: 0.16,
    ttl: 1.22,
    shake: 0.045,
    tone: 540,
    slide: -175,
    color: 0x53ffb5,
    muzzleOffset: [0.18, -0.1, -1.15],
    gripOffset: [0.42, -0.36, -0.78],
    ejectOffset: [0.5, -0.22, -0.55],
    length: 1.15,
  },
  {
    id: 'shotgun',
    name: 'Scatter-12',
    meta: '2 - Burst - Close',
    key: '2',
    cooldown: 0.58,
    pellets: 7,
    spread: 0.22,
    speed: 36,
    damage: 0.92,
    radius: 0.15,
    ttl: 0.66,
    shake: 0.17,
    tone: 250,
    slide: -85,
    color: 0xffd166,
    muzzleOffset: [0.2, -0.08, -1.32],
    gripOffset: [0.42, -0.38, -0.84],
    ejectOffset: [0.54, -0.2, -0.48],
    length: 1.32,
  },
  {
    id: 'rail',
    name: 'Rail Lance',
    meta: '3 - Pierce - Crit',
    key: '3',
    cooldown: 0.88,
    pellets: 1,
    spread: 0,
    speed: 72,
    damage: 4.2,
    radius: 0.25,
    ttl: 1.12,
    pierce: 4,
    shake: 0.25,
    tone: 130,
    slide: 235,
    color: 0x6aa9ff,
    muzzleOffset: [0.18, -0.09, -1.55],
    gripOffset: [0.44, -0.36, -0.94],
    ejectOffset: [0.55, -0.2, -0.56],
    length: 1.55,
  },
  {
    id: 'plasma',
    name: 'Nova Disc',
    meta: '4 - AOE - Slow',
    key: '4',
    cooldown: 0.72,
    pellets: 1,
    spread: 0.02,
    speed: 34,
    damage: 2.8,
    radius: 0.31,
    ttl: 1.38,
    pierce: 1,
    explode: 1,
    freeze: 0.18,
    shake: 0.14,
    tone: 380,
    slide: 180,
    color: 0xff70d7,
    muzzleOffset: [0.16, -0.08, -0.86],
    gripOffset: [0.38, -0.34, -0.62],
    ejectOffset: [0.44, -0.22, -0.42],
    length: 0.86,
  },
];

export function getWeapon(index = 0) {
  return weaponDefs[index] || weaponDefs[0];
}

export function getWeaponById(id) {
  return weaponDefs.find((weapon) => weapon.id === id) || weaponDefs[0];
}
